import { Component, ViewChild, AfterViewInit, OnInit, Inject, ElementRef } from '@angular/core';
import { HttpClient, HttpRequest, HttpEventType, HttpParams, HttpResponse } from '@angular/common/http';
import { MasterService } from '../services/master-service';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA, MatPaginator, MatTableDataSource, MatSort } from '@angular/material';
import { FormControl, Validators, FormBuilder, FormGroup } from '@angular/forms';
import { Router, ActivatedRoute } from '@angular/router';
import { AuthService } from '../services/auth.service';
import { CommonService } from '../services/common-service';

//grid
import { jqxGridComponent } from 'jqwidgets-scripts/jqwidgets-ts/angular_jqxgrid';
import { jqxDropDownListComponent } from 'jqwidgets-scripts/jqwidgets-ts/angular_jqxdropdownlist';
import { jqxInputComponent } from 'jqwidgets-scripts/jqwidgets-ts/angular_jqxinput';
import { jqxWindowComponent } from 'jqwidgets-scripts/jqwidgets-ts/angular_jqxwindow';
import { jqxLoaderComponent } from 'jqwidgets-scripts/jqwidgets-ts/angular_jqxloader';
import { jqxEditorComponent } from 'jqwidgets-scripts/jqwidgets-ts/angular_jqxeditor';


@Component({
  templateUrl: '../main.component.html'
})

export class ItemListComponent implements OnInit {
  public menuName = "Master";
  public titleName = "Item";
  public clickOpen = "Rowdoubleclick($event)";
  //public rowscount = 0;
  public edited = true;
  public isSearchDate = false;
  @ViewChild('cellBeginEditLog') cellBeginEditLog: ElementRef;
  @ViewChild('cellEndEditLog') cellEndEditLog: ElementRef;
  @ViewChild('myGrid') myGrid: jqxGridComponent;
  @ViewChild('myDropDownList') myDropDownList: jqxDropDownListComponent;
  @ViewChild('myInput') myInput: jqxInputComponent;
  @ViewChild('myWindow') myWindow: jqxWindowComponent;
  @ViewChild('MyLoader') MyLoader: jqxLoaderComponent;

  delrows: Array<any> = [];
  selectedcell: any;
  errorMessage: any;
  successMessage: any;
  first_flg: boolean = true;
  loading_flg: boolean = true;

  //get source
  constructor(private _masterService: MasterService, private _router: Router, public dialog: MatDialog) {
  }

  ngOnInit() {
    this.getItems();
  }

  getItems() {
    this.loading_flg = true;
    if (!(this.first_flg)) {
      this.MyLoader.open();
    }
    this._masterService.getItems(false).subscribe((data) => {
      this.source.localdata = data;
      //this.rowscount = data.length;
      this.dataAdapter.dataBind();
      if (!(this.first_flg)) {
        this.MyLoader.close();
      }
      this.first_flg = false;
      this.loading_flg = false;
    });
  }

  //Popup
  Rowdoubleclick(event: any): void {
    let selectedrowindex = this.myGrid.getselectedrowindex();
    let id = this.myGrid.getrowdata(selectedrowindex).item_id;
    let dialogRef = this.dialog.open(PopupItemComponent, {
      width: '1000px',
      //height: 'auto*',
      disableClose: true,//20191007 close無し
      data: {
        item_id: id
      }
    });

    dialogRef.afterClosed().subscribe(
      (result) => {
        //20191008 自分のタイミングで更新するように
        //this.getItems();
      });
  }
  //tool bar
  ngAfterViewInit(): void {
    this.createButtons();
  }
  dropDownSource: string[] = ['Id','Description', 'Inactive'];
  groups: any[] = [];
  getPagesize(): any {
    return 20;
  }
  //grid 
  source: any =
    {
      datatype: 'json',
      datafields: [
        { name: 'item_id', type: 'int' },
        { name: 'description', type: 'string' },
        { name: 'inactive', type: 'bool' }
      ],
      id: 'item_id',
      localdata: {},
      sortcolumn: 'item_id'
    };
  dataAdapter: any = new jqx.dataAdapter(this.source);

  getWidth(): any {
    return '100%';
  }
  getTotal(): any {
    return false;
  }
  //columns
  columns: any[] =
    [
      { text: 'Id', datafield: 'item_id', width: '10%', align: 'right', cellsalign: 'right', columntype: 'textbox', editable: false },
      {
        text: 'Description', datafield: 'description', width: '80%', columntype: 'textbox', editable: false,
        validation: (cell: any, value: any): any => {
          if (value.length > 100) {
            return { result: false, message: 'Description must be less than 100 letters.' };
          }
          return true;
        }
      },
      { text: 'Inactive', datafield: 'inactive', width: '10%', columntype: 'checkbox', twostatecheckbox: true, align: 'center', editable: false }
    ];

  groupsrenderer(text, group, expanded, data): any {
   var color;
    switch (data.level) {
      case 0:
        color = '#B0BEC5';
        break;
      case 1:
        color = '#CFD8DC';
        break;
      case 2:
        color = '#ECEFF1';
        break;
      case 3:
        color = '#EEEEEE';
        break;
      case 4:
        color = '#F5F5F5';
        break;
      case 5:
        color = '#FAFAFA';
        break;
    } 
    return '<div style="width: 100%; height: 100%; background-color: #CFD8DC; color:Black; line-height:30px;"><span style="font-weight:bold; vertical-align: middle;">' + text + '</span></div>';
  }

  //add row
  //generatedata(): any {
  //  let row = {};
  //  row['item_id'] = 0;
  //  row['description'] = "";
  //  row['inactive'] = false;

  //  return row;
  //}

  //tool buttons
  createButtonsContainers(statusbar: any): void {
    let buttonsContainer = document.createElement('div');
    buttonsContainer.style.cssText = 'overflow: hidden; position: relative; margin: 5px;';
    let addButtonContainer = document.createElement('div');
    //let deleteButtonContainer = document.createElement('div');
    let reloadButtonContainer = document.createElement('div');
    //let searchButtonContainer = document.createElement('div');
    //let saveButtonContainer = document.createElement('div');
    addButtonContainer.id = 'addButton';
    //deleteButtonContainer.id = 'deleteButton';
    reloadButtonContainer.id = 'reloadButton';
    //searchButtonContainer.id = 'searchButton';
    //saveButtonContainer.id = 'saveButton';
    addButtonContainer.style.cssText = 'float: left; margin-left: 5px;';
    //deleteButtonContainer.style.cssText = 'float: left; margin-left: 5px;';
    reloadButtonContainer.style.cssText = 'float: left; margin-left: 5px;';
    //searchButtonContainer.style.cssText = 'float: left; margin-left: 5px;';
    //saveButtonContainer.style.cssText = 'float: right; margin-right: 5px;';
    addButtonContainer.className = 'btn btn-default';
    //deleteButtonContainer.className = 'btn btn-default';
    reloadButtonContainer.className = 'btn btn-default';
    //searchButtonContainer.className = 'btn btn-default';
    //saveButtonContainer.className = 'btn btn-default';
    buttonsContainer.appendChild(addButtonContainer);
    //buttonsContainer.appendChild(deleteButtonContainer);
    buttonsContainer.appendChild(reloadButtonContainer);
    //buttonsContainer.appendChild(searchButtonContainer);
    //buttonsContainer.appendChild(saveButtonContainer);
    statusbar[0].appendChild(buttonsContainer);
  }

  //create tool buttons
  createButtons(): void {
    let addButtonOptions = {
      width: 40, height: 25,
      theme: "material",
      value: "<span class='glyphicon glyphicon-plus' style='color:darkseagreen;' title='Add'></span>"
    }
    let addButton = jqwidgets.createInstance('#addButton', 'jqxButton', addButtonOptions);
    //let deleteButtonOptions = {
    //  width: 40, height: 25,
    //  theme: "material",
    //  value: "<span class='glyphicon glyphicon-remove' style='color:indianred;' title='Delete'></span>"
    //}
    //let deleteButton = jqwidgets.createInstance('#deleteButton', 'jqxButton', deleteButtonOptions);
    let reloadButtonOptions = {
      width: 40, height: 25,
      theme: "material",
      value: "<span class='glyphicon glyphicon-refresh' style='color:darkblue;' title='Reload'></span>"
    }
    let reloadButton = jqwidgets.createInstance('#reloadButton', 'jqxButton', reloadButtonOptions);
    //let searchButtonOptions = {
    //  width: 40, height: 25,
    //  theme: "material",
    //  value: "<span class='glyphicon glyphicon-search' style='color:slategrey;' title='Find'></span>"
    //}
    //let searchButton = jqwidgets.createInstance('#searchButton', 'jqxButton', searchButtonOptions);
    //let saveButtonOptions = {
    //  width: 40, height: 25,
    //  theme: "material",
    //  value: "<span class='glyphicon glyphicon-floppy-disk' style='color:#2E7D32;' title='Save'></span>"
    //}
    //let saveButton = jqwidgets.createInstance('#saveButton', 'jqxButton', saveButtonOptions);

    // add new row.
    addButton.addEventHandler('click', (event: any): void => {
      let id = 0;
      let dialogRef = this.dialog.open(PopupItemComponent, {
        width: '900px',
        //height: 'auto*',
        disableClose: true,//20191007 close無し
        data: {
          item_id: id
        }
      });
      dialogRef.afterClosed().subscribe(
        (result) => {
          //20191008 自分のタイミングで更新するように
          //this.getItems();
        });
    });
    // delete selected row.
    //deleteButton.addEventHandler('click', (event: any): void => {
    //  let selectedrowindex = this.myGrid.getselectedrowindex();
    //  let rowscount = this.myGrid.getdatainformation().rowscount;
    //  let id = this.myGrid.getrowid(selectedrowindex);
    //  this.myGrid.deleterow(id);
    //  this.delrows.push(id);
    //});
    // reload grid data.
    reloadButton.addEventHandler('click', (event: any): void => {
      this.getItems();
      this.delrows = [];
      this.selectedcell = null;
    });
    // search for a record.
    //searchButton.addEventHandler('click', (event: any): void => {
    //  this.myWindow.open();
    //  this.myWindow.move(60, 60);
    //});
    // save records.
    //saveButton.addEventHandler('click', (event: any): void => {
    //  this.errorMessage = null;
    //  this.successMessage = 'You have successfully saved the data.';

    //  //confirm changes
    //  let selectedrowindex = this.myGrid.getselectedrowindex();
    //  this.myGrid.endcelledit(selectedrowindex, this.selectedcell, false);

    //  for (var i = 0; i < this.myGrid.getrows().length; i++) {
    //    let item = this.myGrid.getrowdata(i);
    //    if (item.description.length > 100
    //      || item.description == "") {
    //      this.errorMessage = "Input is invalid. Please check the data.";
    //      this.successMessage = null;
    //      return;
    //    }
    //  }

    //  let rows = this.myGrid.getrows();
    //  rows.forEach(item => {
    //    if (item.item_id == 0) {
    //      this._masterService.addItem(item)
    //        .subscribe(
    //          data => {
    //            //this.getItems();
    //            let index = this.myGrid.getrowboundindexbyid(item.item_id);
    //            item.item_id += data;
    //            this.myGrid.setcellvalue(index, "item_id", data);
    //        },
    //        error => {
    //          this.successMessage = null;
    //          if (error._body != null) {
    //            this.errorMessage += "Some data have not been saved. " + error._body;
    //          } else {
    //            this.errorMessage += error;
    //          }
    //        })
    //    }
    //    else {
    //      this._masterService.updateItem(item)
    //        .subscribe(
    //          data => {
    //          //this.getItems();
    //        },
    //        error => {
    //          this.successMessage = null;
    //          if (error._body != null) {
    //            this.errorMessage += "Some data have not been saved. " + error._body;
    //          } else {
    //            this.errorMessage += error;
    //          }
    //        })
    //    }
    //  });
    //  this.delrows.forEach(itemId => {
    //    if (itemId != 0) {
    //      this._masterService.deleteItem(itemId).subscribe(
    //        data => {
    //          //this.getItems();
    //          if (data != 1) {
    //            this.errorMessage += "Data has not been found : ID " + itemId;
    //          }
    //        },
    //        error => {
    //          this.successMessage = null;
    //          if (error._body != null) {
    //            this.errorMessage += "Some data have not been saved. " + error._body;
    //          } else {
    //            this.errorMessage += error;
    //          }
    //        })
    //    }
    //  });
    //  this.delrows = [];
    //  this.selectedcell = null;
    //});
  }

  //find button
  findBtnOnClick(): void {
    this.myGrid.clearfilters();
    let searchColumnIndex = this.myDropDownList.selectedIndex();
    let datafield = '';
    switch (searchColumnIndex) {
      case 0:
        datafield = 'item_id';
        break;
      case 1:
        datafield = 'description';
        break;
      case 2:
        datafield = 'inactive';
        break;
    }
    let searchText = this.myInput.val();
    let filtergroup = new jqx.filter();
    let filter_or_operator = 1;
    let filtervalue = searchText;
    let filtercondition = 'contains';
    let filter = filtergroup.createfilter('stringfilter', filtervalue, filtercondition);
    filtergroup.addfilter(filter_or_operator, filter);
    this.myGrid.addfilter(datafield, filtergroup);
    // apply the filters.
    this.myGrid.applyfilters();
  }

  //clear btn
  clearBtnOnClick(): void {
    this.myGrid.clearfilters();
  }

  //edit function
  rowValues: string = '';
  myGridOnCellBeginEdit(event: any): void {
    let args = event.args;
    this.selectedcell = args.datafield;
  };
  myGridOnCellEndEdit(event: any): void {
  };

  //print pdf
  btnOnClick() {
    let gridContent = this.myGrid.exportdata('html');
    let newWindow = window.open('', '', 'width=800, height=500'),
      document = newWindow.document.open(),
      pageContent =
        '<!DOCTYPE html>\n' +
        '<html>\n' +
        '<head>\n' +
        '<meta charset="utf-8" />\n' +
        '<title>Item - Report</title>\n' +
        '</head>\n' +
        '<body>\n' + gridContent + '\n</body>\n</html>';
    document.write(pageContent);
    document.close();
    newWindow.print();
  };

  //export excel
  excelBtnOnClick() {
    this.myGrid.exportdata('xls', 'Item');
  };

  onPageChanged(): void {
    this.myGrid.expandallgroups();
  }

  //Close Message
  closeSuccessMessage() {
    this.successMessage = null;
  }
  closeErrorMessage() {
    this.errorMessage = null;
  }
}


//****************************************************
// Popup
//****************************************************

@Component({
  selector: 'app-popup-item',
  templateUrl: 'popup-item.component.html',
  styleUrls: ['./master-popup.component.css'],
})
export class PopupItemComponent implements OnInit {
  title: string = "(Create)";
  Form: FormGroup;
  errorMessage: any;
  successMessage: any;
  selectedcell: any;
  delrows: Array<any> = [];
  user: any;

  constructor(
    public dialogRef: MatDialogRef<PopupItemComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private _masterService: MasterService,
    private _authService: AuthService,
    private _fb: FormBuilder, private _com: CommonService
  ) {
    var today = new Date();
    var todayStr = this._com.getDateTime(new Date());
    this.user = this._authService.getAuthLoginName();
    this.Form = this._fb.group({
      item_id: 0,
      description: ['', Validators.required],
      updated_by: this.user,
      updated_date: todayStr,
      inactive: false
    })
  }

  ngOnInit() {
    this.getItemById(this.data.item_id);
  }

  ngAfterViewInit(): void {
  }

  getItemById(id) {
    if (id > 0) {
      this.title = '(Edit/View)'
      this._masterService.getItemById(id)
        .subscribe(
          res => {
            this.Form.setValue(res);
          },
          error => this.errorMessage = error._body
        );
    }
  }

  getWidth(): any {
    return '100%';
  }

  getHeight(): any {
    return '70%';
  }

  //Save Data
  saveItem() {
    //check form
    if (this.Form.invalid) {
      this.errorMessage = 'Please enter all required fields.';
      return;
    }

    this.errorMessage = null;
    this.successMessage = null;
    var today = new Date();
    var todayStr = this._com.getDateTime(new Date());
    this.Form.value.updated_by = this.user;
    this.Form.value.updated_date = todayStr;
    if (this.item_id.value == 0) {
      this._masterService.addItem(this.Form.value)
        .subscribe(
          data => {
            if (data > 0) {
              this.successMessage = "You have successfully added the data.";
              this.getItemById(data);
            } else {
              this.errorMessage = "Failed to save the data. ";
            }
          },
          error => {
            this.successMessage = null;
            if (error != null) {
              this.errorMessage = error._body;
            }
            else {
              this.errorMessage = "Failed to save the data. ";
            }
          });
    }
    else {
      this._masterService.updateItem(this.Form.value)
        .subscribe(
          data => {
            if (data > 0) {
              this.successMessage = "You have successfully updated the data.";
              this.getItemById(data);
            } else {
              this.errorMessage = "Failed to update the data. ";
            }
          },
          error => {
            this.successMessage = null;
            if (error != null) {
              this.errorMessage = error._body;
            }
            else {
              this.errorMessage = "Failed to update the data. ";
            }
          });
    }
  }

  //Delete Data
  deleteItem() {
    if (!confirm("Are you sure you want to delete this data?")) {
      console.log('no');
      return;
    }

    if (this.item_id.value != 0) {

      let id = this.item_id.value;

      this._masterService.deleteItem(id)
        .subscribe(
          data => {
            if (data == 1) {
              this.dialogRef.close();
            }
            else {
              this.errorMessage = ' Failed to delete the data.';
            }
          },
          error => {
            if (error != null) {
              this.errorMessage = error._body;
            }
            else {
              this.errorMessage = "Failed to delete the data. ";
            }
          }
        )
    };
  }

  //Close Message
  closeSuccessMessage() {
    this.successMessage = null;
  }
  closeErrorMessage() {
    this.errorMessage = null;
  }

  get item_id() { return this.Form.get('item_id'); }
  get description() { return this.Form.get('description'); }
  get inactive() { return this.Form.get('inactive'); }
  get updated_by() { return this.Form.get('updated_by'); }
  get updated_date() { return this.Form.get('updated_date'); }
}



// WEBPACK FOOTER //
// ./src/app/master/item-list.component.ts